import routes from './routes/shop.routes';
import ModuleBase from '../../classes/ModuleBase';

export default new ModuleBase({
    name: 'Shop',
    routes: routes
});